module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_3009.b8822dc1.png";